import styled from '@emotion/styled';

const LayoutContainer = styled.section`
  display: flex;
  height: 100vh;
`;

export { LayoutContainer };
